module.exports = __webpack_public_path__ + "assets/lineIcon.9f80f864.svg";